import {
  getSubscriptionOption as publicGetSubscriptionOption,
  getSubscriptionOptionsForProduct as publicGetSubscriptionOptionsForProduct,
  getProductIdsForSubscriptionOption as publicGetProductIdsForSubscriptionOption,
  getOneTimePurchasesStatus as publicGetOneTimePurchasesStatus,
  createSubscriptionOption as publicCreateSubscriptionOption,
  updateSubscriptionOption as publicUpdateSubscriptionOption,
  deleteSubscriptionOption as publicDeleteSubscriptionOption,
  bulkCreateSubscriptionOptions as publicBulkCreateSubscriptionOptions,
  bulkUpdateSubscriptionOptions as publicBulkUpdateSubscriptionOptions,
  bulkDeleteSubscriptionOptions as publicBulkDeleteSubscriptionOptions,
  assignSubscriptionOptionsToProduct as publicAssignSubscriptionOptionsToProduct,
  allowOneTimePurchases as publicAllowOneTimePurchases,
} from './stores-v1-subscription-option-subscription-options.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getSubscriptionOption: MaybeContext<
  BuildRESTFunction<typeof publicGetSubscriptionOption> &
    typeof publicGetSubscriptionOption
> = /*#__PURE__*/ createRESTModule(publicGetSubscriptionOption);
export const getSubscriptionOptionsForProduct: MaybeContext<
  BuildRESTFunction<typeof publicGetSubscriptionOptionsForProduct> &
    typeof publicGetSubscriptionOptionsForProduct
> = /*#__PURE__*/ createRESTModule(publicGetSubscriptionOptionsForProduct);
export const getProductIdsForSubscriptionOption: MaybeContext<
  BuildRESTFunction<typeof publicGetProductIdsForSubscriptionOption> &
    typeof publicGetProductIdsForSubscriptionOption
> = /*#__PURE__*/ createRESTModule(publicGetProductIdsForSubscriptionOption);
export const getOneTimePurchasesStatus: MaybeContext<
  BuildRESTFunction<typeof publicGetOneTimePurchasesStatus> &
    typeof publicGetOneTimePurchasesStatus
> = /*#__PURE__*/ createRESTModule(publicGetOneTimePurchasesStatus);
export const createSubscriptionOption: MaybeContext<
  BuildRESTFunction<typeof publicCreateSubscriptionOption> &
    typeof publicCreateSubscriptionOption
> = /*#__PURE__*/ createRESTModule(publicCreateSubscriptionOption);
export const updateSubscriptionOption: MaybeContext<
  BuildRESTFunction<typeof publicUpdateSubscriptionOption> &
    typeof publicUpdateSubscriptionOption
> = /*#__PURE__*/ createRESTModule(publicUpdateSubscriptionOption);
export const deleteSubscriptionOption: MaybeContext<
  BuildRESTFunction<typeof publicDeleteSubscriptionOption> &
    typeof publicDeleteSubscriptionOption
> = /*#__PURE__*/ createRESTModule(publicDeleteSubscriptionOption);
export const bulkCreateSubscriptionOptions: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateSubscriptionOptions> &
    typeof publicBulkCreateSubscriptionOptions
> = /*#__PURE__*/ createRESTModule(publicBulkCreateSubscriptionOptions);
export const bulkUpdateSubscriptionOptions: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateSubscriptionOptions> &
    typeof publicBulkUpdateSubscriptionOptions
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateSubscriptionOptions);
export const bulkDeleteSubscriptionOptions: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteSubscriptionOptions> &
    typeof publicBulkDeleteSubscriptionOptions
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteSubscriptionOptions);
export const assignSubscriptionOptionsToProduct: MaybeContext<
  BuildRESTFunction<typeof publicAssignSubscriptionOptionsToProduct> &
    typeof publicAssignSubscriptionOptionsToProduct
> = /*#__PURE__*/ createRESTModule(publicAssignSubscriptionOptionsToProduct);
export const allowOneTimePurchases: MaybeContext<
  BuildRESTFunction<typeof publicAllowOneTimePurchases> &
    typeof publicAllowOneTimePurchases
> = /*#__PURE__*/ createRESTModule(publicAllowOneTimePurchases);

export {
  SubscriptionFrequency,
  DiscountType,
} from './stores-v1-subscription-option-subscription-options.universal.js';
export {
  SubscriptionOption,
  SubscriptionSettings,
  Discount,
  GetSubscriptionOptionRequest,
  GetSubscriptionOptionResponse,
  GetSubscriptionOptionsForProductRequest,
  GetSubscriptionOptionsForProductResponse,
  SubscriptionOptionInProduct,
  ListSubscriptionOptionsRequest,
  ListSubscriptionOptionsResponse,
  CalculatePricesRequest,
  CalculatePricesResponse,
  SubscriptionOptionPrices,
  SubscriptionOptionPriceData,
  BulkCalculatePricesRequest,
  BulkCalculatePricesResponse,
  BulkCalculatePricesRequestV2,
  BulkCalculatePricesRequestItem,
  BulkCalculatePricesResponseV2,
  BulkCalculatePricesResponseItem,
  GetProductIdsForSubscriptionOptionRequest,
  Paging,
  GetProductIdsForSubscriptionOptionResponse,
  PagingMetadata,
  GetOneTimePurchasesStatusRequest,
  GetOneTimePurchasesStatusResponse,
  CreateSubscriptionOptionRequest,
  CreateSubscriptionOptionResponse,
  UpdateSubscriptionOptionRequest,
  UpdateSubscriptionOptionResponse,
  DeleteSubscriptionOptionRequest,
  DeleteSubscriptionOptionResponse,
  BulkCreateSubscriptionOptionsRequest,
  BulkCreateSubscriptionOptionsResponse,
  BulkUpdateSubscriptionOptionsRequest,
  BulkUpdateSubscriptionOptionsResponse,
  BulkDeleteSubscriptionOptionsRequest,
  BulkDeleteSubscriptionOptionsResponse,
  AssignSubscriptionOptionsToProductRequest,
  AssignSubscriptionOptionsToProductResponse,
  AllowOneTimePurchasesRequest,
  AllowOneTimePurchasesResponse,
  GetSubscriptionOptionsForProductOptions,
  GetProductIdsForSubscriptionOptionOptions,
  UpdateSubscriptionOption,
  AssignSubscriptionOptionsToProductOptions,
} from './stores-v1-subscription-option-subscription-options.universal.js';
export {
  SubscriptionFrequencyWithLiterals,
  DiscountTypeWithLiterals,
} from './stores-v1-subscription-option-subscription-options.universal.js';
